module.exports = __webpack_public_path__ + "static/img/icon_scyhk.7d0e1d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icon_scyhk.png
// module id = mCFi
// module chunks = 1